import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'

// import api from './axios/api';
// createApp.prototype.$api = api;


import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import api from './axios/api';




const app=createApp(App)
app.use(router).use(router).use(ElementPlus).mount('#app')

app.config.globalProperties.$api=api